import React from "react";
import BuildingOverview from "../../Components/BuildingOverview/BuildingOverview";
import BuildingDataT4Base from "../../data/raw/building/base";
import {TranslationProvider} from "./TranslationProvider";
import {useNavigate, useParams} from "react-router-dom";

export default function BuildingOverviewFrame() {
    const params = useParams();
    const navigate = useNavigate();

    let gid: number|undefined = Number(params.gid);
    if (isNaN(gid)) {
        gid = undefined;
    }

    function setSelectedBuilding(newGid: null|number) {
        navigate((gid !== undefined ? '..' : '.') + (newGid === null ? '' : '/') + (newGid ?? ''), { relative: "path" });
    }

    const supportedLanguages = ['ar-AE', 'cs-CZ', 'fr-FR', 'de-DE', 'it-IT', 'pl-PL', 'pt-PT', 'ru-RU', 'es-ES', 'tr-TR'];

    return <TranslationProvider initialLanguage={supportedLanguages.includes(params.language) ? params.language : 'en-US'}>
        <BuildingOverview
            getBuildingBaseData={async () => BuildingDataT4Base}
            getBuildingData={async (gid) => BuildingDataT4Base.filter(k => k.gid === gid)[0]}
            selectedBuilding={gid}
            setSelectedBuilding={setSelectedBuilding}
        />
    </TranslationProvider>
}
